// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"d9f5cc2e","455":"105ab695","977":"b6c2e695"}[chunkId] + ".chunk.js";
};